import request from '@/utils/request.js'
import requestLogin from "@/utils/requestLogin";

// 登录
function login(data) {
    return request({
        url: '/api/v1/tob/login',
        method: 'post',
        data
    })
}

// 退出
function logout(data) {
    return request({
        url: '/api/v1/tob/logout',
        method: 'post',
        data
    })
}

// 修改密码
function editPassword(data) {
    return request({
        url: '/api/v1/tob/password',
        method: 'post',
        data
    })
}

// 个人信息
function tobMe(data) {
    return request({
        url: '/api/v1/tob/me',
        method: 'get',
        params:data
    })
}

// 角色列表
function roleList(data) {
    return request({
        url: '/api/v1/tob/accounts/role',
        method: 'get',
        params:data
    })
}

// 提交审核
function accountsCheck(data) {
    return request({
        url: '/api/v1/tob/accounts/check',
        method: 'post',
        data
    })
}

// 首页
function homeData(data) {
    return request({
        url: '/api/v1/tob',
        method: 'get',
        params:data
    })
}

// 首页
function subjectsList(data) {
    return request({
        url: '/api/v1/subjects_list',
        method: 'get',
        params:data
    })
}

// 查看导入记录
function studentsImportList(data) {
    return request({
        url: '/api/v1/tob/students/import-list',
        method: 'get',
        params:data
    })
}

// 查看导入记录详情
function studentsImportListDetail(data) {
    return request({
        url: '/api/v1/tob/students/import-detail',
        method: 'get',
        params:data
    })
}

// 取消审核
function accountsUnCheck(data) {
    return request({
        url: '/api/v1/tob/accounts/un-check',
        method: 'post',
        data
    })
}

// 图片上传
const fileUpload = data => request.post('/admin/v1/downpage/upload-file', data)

// const getInfoToName = params => request({
//     url: `dictionary/info/name/${params.name}`,
//     method: 'get',
//     params
//   })

function getInfoToName(params) {
    return request({
        url: `api/v1/dictionary`,
        method: 'get',
        params
    })
}

function getDictionaries(params) {
    return request({
        url: `/api/v1/dictionaries`,
        method: 'get',
        params
    })
}


// 下载机构分享图片
function getDownGroupImg(data) {
    return request({
        url: '/api/v1/tob/downGroupImg',
        method: 'get',
        params:data
    })
}

// 获取省
function getProvinces(data) {
    return request({
        url: '/admin/v1/area/list',
        method: 'get',
        params:data
    })
}
// 获取市
function getCitys(data) {
    return request({
        url: `/admin/v1/area/child-list/${data.id}`,
        method: 'get',
        params:data
    })
}

// 提交反馈
function addComplaint(data) {
    return request({
        url: '/api/v1/tob/add-complaint',
        method: 'post',
        data
    })
}

// 任务列表 /api/v1/tob/task
function getTobTask(data) {
    return request({
        url: '/api/v1/tob/task',
        method: 'get',
        params:data
    })
}

// 删除任务 /api/v1/tob/deltask
function tobDelTask(data) {
    return request({
        url: '/api/v1/tob/deltask',
        method: 'post',
        data
    })
}

// 机构下所有任务 /api/v1/tob/alltask
function getTobAllTask(data) {
    return request({
        url: '/api/v1/tob/alltask',
        method: 'get',
        params:data
    })
}

// 机构下所有员工 /api/v1/tob/allaccount
function getTobAllAcCount(data) {
    return request({
        url: '/api/v1/tob/allaccount',
        method: 'get',
        params:data
    })
}

// 机构-分配用户 /api/v1/tob/allot
function tobAllot(data) {
    return request({
        url: '/api/v1/tob/allot',
        method: 'post',
        data
    })
}

// 显示列表设置  /api/v1/tob/updatefield
function tobUpDateField(data) {
    return request({
        url: '/api/v1/tob/updatefield',
        method: 'post',
        data
    })
}

// 【机构端】展示字段配置保存 /api/v1/tob/save-show-field-config
function saveShowFieldConfig(data) {
    return request({
        url: '/api/v1/tob/save-show-field-config',
        method: 'post',
        data
    })
}


// 仅修改单个任务名称 /api/v1/tob/edittaskname
function edittaskname(data) {
    return request({
        url: '/api/v1/tob/edittaskname',
        method: 'post',
        data
    })
}

// 备注列表
function getTobRemarks(data) {
    return request({
        url: '/api/v1/tob/remarks',
        method: 'get',
        params:data
    })
}

// 备注添加/修改
function remarkDo(data) {
    return request({
        url: '/api/v1/tob/remarkdo',
        method: 'post',
        data
    })
}

// 备注删除
function remarkDel(data) {
    return request({
        url: '/api/v1/tob/remarkdel',
        method: 'post',
        data
    })
}

// 数据统计
function getTobDataTongJi(data) {
    return request({
        url: '/api/v1/tob/datatongji',
        method: 'get',
        params:data
    })
}

// 单个转移
function tobMoveOne(data) {
    return request({
        url: '/api/v1/tob/move-one',
        method: 'post',
        data
    })
}

// 多个转移
function tobMoveMore(data) {
    return request({
        url: '/api/v1/tob/move-more',
        method: 'post',
        data
    })
}

// 开启/关闭公共标签
function tobCommonTagDo(data) {
    return request({
        url: '/api/v1/tob/commontagdo',
        method: 'post',
        data
    })
}

// 搜索框标签列表
function getTobSearchTags(data) {
    return request({
        url: '/api/v1/tob/searchtags',
        method: 'get',
        params:data
    })
}

// 开卡列表
function getTobStudyCard(data) {
    return request({
        url: '/api/v1/tob/study-card',
        method: 'get',
        params:data
    })
}

// 开卡商品列表
function getTobStudyCardGoods(data) {
    return request({
        url: '/api/v1/tob/study-card-goods',
        method: 'get',
        params:data
    })
}

// 【机构端】开卡
function tobStudyCardAdd(data) {
    return request({
        url: '/api/v1/tob/study-card-add',
        method: 'post',
        data
    })
}

// 学习卡导出
function getTobStudyCardExport(data) {
    return request({
        url: '/api/v1/tob/study-card-export',
        method: 'get',
        params:data
    })
}


// 【机构端】学习卡Excel数据下载中心 /api/v1/tob/study-card/export-log
function getTobStudyCardExportLog(data) {
    return request({
        url: '/api/v1/tob/study-card/export-log',
        method: 'get',
        params:data
    })
}

// 【机构后台】海报列表 /api/v1/tob/tob-poster-list
function getTobPosterList(data) {
    return request({
        url: '/api/v1/tob/tob-poster-list',
        method: 'get',
        params:data
    })
}

// 【机构后台】海报详情 /api/v1/tob/tob-poster-info/{id}
function getTobPosterInfo(data) {
    return request({
        url: `/api/v1/tob/tob-poster-info/${data.id}`,
        method: 'get',
        params:data
    })
}

// 【机构后台】保存用户海报信息 /api/v1/tob/tob-poster-save
function tobPosterSave(data) {
    return request({
        url: '/api/v1/tob/tob-poster-save',
        method: 'post',
        data
    })
}

// 机构后台-结算列表  /api/v1/tob/marketing
function getTobMarketing(data) {
    return request({
        url: '/api/v1/tob/marketing',
        method: 'get',
        params:data
    })
}

// 机构后台-确认银行信息 /api/v1/tob/bank/confirm
function tobBankConfirm(data) {
    return request({
        url: '/api/v1/tob/bank/confirm',
        method: 'post',
        data
    })
}


// 机构后台-填写银行信息 /api/v1/tob/bank/save
function tobBankSave(data) {
    return request({
        url: '/api/v1/tob/bank/save',
        method: 'post',
        data
    })
}

// 【机构端】文件夹列表  /api/v1/tob/tob-folder-list
function getTobFolderList(data) {
    return request({
        url: '/api/v1/tob/tob-folder-list',
        method: 'get',
        params:data
    })
}

// 【机构端】文件列表/api/v1/tob/tob-folder-file-list/{folder_id}
function getTobFolderFileList(data) {
    return request({
        url: `/api/v1/tob/tob-folder-file-list/${data.folder_id}`,
        method: 'get',
        params:data
    })
}

// 机构后台-修改登录手机 /api/v1/tob/mobile
function tobMobile(data) {
    return request({
        url: '/api/v1/tob/mobile',
        method: 'post',
        data
    })
}

// 【机构后台】体验信息 /api/v1/tob/experience-info
function getTobExperienceInfo(data) {
    return request({
        url: '/api/v1/tob/experience-info',
        method: 'get',
        params:data
    })
}

// 【机构后台】体验账号更新 /api/v1/tob/experience-account-update
function experienceAccountUpdate(data) {
    return request({
        url: '/api/v1/tob/experience-account-update',
        method: 'post',
        data
    })
}

// 【机构后台】学员学习数据统计列表  /api/v1/tob/tongji-study
function getTobTongJiStudy(data) {
    return request({
        url: '/api/v1/tob/tongji-study',
        method: 'get',
        params:data
    })
}

// 【机构后台】搜索创建人  /api/v1/tob/search-create-user
function getTobSearchCreateUser(data) {
    return request({
        url: '/api/v1/tob/search-create-user',
        method: 'get',
        params:data
    })
}

function getTobStudents(data) {
    return request({
        url: '/api/v1/tob/students',
        method: 'get',
        params:data
    })
}

// 获取验证码的安全码
function getVertifyCode(data) {
    return request({
        url: '/check-captcha',
        method: 'get',
        params:data
    })
}

// 公告列表 /admin/v1/tob/notice-list
function getNoticeList(data) {
    return request({
        url: '/api/v1/tob/notice-list',
        method: 'get',
        params:data
    })
}

// 公告详情 /api/v1/tob/notice-info/{id}
function getTobNoticeInfo(data) {
    return request({
        url: `/api/v1/tob/notice-info/${data.id}`,
        method: 'get',
        params:data
    })
}

// 视频列表 /api/v1/tob/video-list
function getVideoList(data) {
    return request({
        url: '/api/v1/tob/video-list',
        method: 'get',
        params:data
    })
}

// 视频详情 /api/v1/tob/video-info/{id}
function getTobVideoInfo(data) {
    return request({
        url: `/api/v1/tob/video-info/${data.id}`,
        method: 'get',
        params:data
    })
}

// 批量操作学员  /api/v1/tob/students/batch
function studentsBatch(data) {
    return request({
        url: '/api/v1/tob/students/batch',
        method: 'post',
        data
    })
}

// 机构有订单的学员总数（批量操作学员时） /api/v1/tob/has-order-student-count
function getHasOrderStudentCount(data) {
    return request({
        url: '/api/v1/tob/has-order-student-count',
        method: 'get',
        params:data
    })
}

// 学员详情 /api/v1/tob/students/info/{uid}
function getTobStudentsInfo(data) {
    return request({
        url: `/api/v1/tob/students/info/${data.uid}`,
        method: 'get',
        params:data
    })
}

// 学员详情数据信息 /api/v1/tob/students/datas/{uid}
function getTobStudentsDatas(data) {
    return request({
        url: `/api/v1/tob/students/datas/${data.uid}`,
        method: 'get',
        params:data
    })
}

// 帮助手册_列表 /api/v1/tob/help-manual-list
function getTobHelpManualList(data) {
    return request({
        url: '/api/v1/tob/help-manual-list',
        method: 'get',
        params:data
    })
}
 
// 帮助手册_详情 /api/v1/tob/help-manual-info/{id}
function getTobHelpManualInfo(data) {
    return request({
        url: `/api/v1/tob/help-manual-info/${data.id}`,
        method: 'get',
        params:data
    })
}
 
// 小程序二维码 /api/v1.6.8/activity/xcx-code
function getActivityXcxCode(data) {
    return request({
        url: '/api/v1.6.8/activity/xcx-code',
        method: 'get',
        params:data
    })
}


// 后端-院校列表- 只有ID和name
const getCollegeNameList = params => request({
  url: '/api/v1/tob/college/all',
  method: 'get',
  params
})
// 模式二考试类  /admin/v1/dzs-cate-mode2
const getDzsCateMode2 = params => request({
  url: `/api/v1/tob/dzs-cate-mode2`,
  method: 'get',
  params
})
// 院校招生计划列表 /admin/v1/question/edus/plan
const getQuestionEdusPlan = params => request({
  url: `/api/v1/tob/question/edus/plan`,
  method: 'get',
  params
})
// 定制化资料筛选科目
const getExamOutLintSubjects = params => request({
  url: `/api/v1/tob/examoutline-subject`,
  method: 'get',
  params
})

// 通用-获取省份列表
const getAreaList = params => request({
  url: `/api/v1/tob/area/list`,
  method: 'get',
  params
})

const getAllArea = params => request({
  url: `/api/v1/tob/area/all-list`,
  method: 'get',
  params
})

// 单招省份列表 /admin/v1/question/edus 
const getQuestionEdus = params => request({
  url: `/api/v1/tob/question/edus`,
  method: 'get',
  params
})


// 机构后台_定制订单保存 /api/v1/tob/custom-order-save
function customOrderSave(data) {
    return request({
        url: `/api/v1/tob/custom-order-save`,
        method: 'post',
        data
    })
}

// 交易流水接口 /api/v1/tob/custom-order-flowing 充值列表：写死传参type=1 支出列表：写死传参type=2
const getCustomOrderFlowing = params => request({
  url: `/api/v1/tob/custom-order-flowing`,
  method: 'get',
  params
})


// 机构后台_定制订单列表 /api/v1/tob/custom-order-list
function getCustomOrderList(data) {
    return request({
        url: '/api/v1/tob/custom-order-list',
        method: 'get',
        params:data
    })
}
 
// 模式二科目列表(考钢) /api/v1/tob/examoutline-subject-mode2
function getExamoutlineSubjectMode2(data) {
    return request({
        url: '/api/v1/tob/examoutline-subject-mode2',
        method: 'get',
        params:data
    })
}

function getUserinfo(data) {
    return request({
        url: '/api/v1/tob/question/statistics-userlist',
        method: 'get',
        params:data
    })
}

// 机构后台_机构商品信息 /api/v1/tob/tob-good-info/{id}
function getTobGoodInfo(data) {
    return request({
        url: `/api/v1/tob/tob-good-info/${data.id}`,
        method: 'get',
        params:data
    })
}

  
 
export default {
    getVertifyCode,
    getCitys,
    getProvinces,
    login,
    logout,
    editPassword,
    tobMe,
    roleList,
    fileUpload,
    accountsCheck,
    homeData,
    subjectsList,
    studentsImportList,
    studentsImportListDetail,
    accountsUnCheck,
    getInfoToName,
    getDictionaries,
    getDownGroupImg,
    addComplaint,
    getTobTask,
    tobDelTask,
    getTobAllTask,
    getTobAllAcCount,
    tobAllot,
    tobUpDateField,
    saveShowFieldConfig,
    edittaskname,
    getTobRemarks,
    remarkDo,
    remarkDel,
    getTobDataTongJi,
    tobMoveOne,
    tobMoveMore,
    tobCommonTagDo,
    getTobSearchTags,
    getTobStudyCard,
    getTobStudyCardGoods,
    tobStudyCardAdd,
    getTobStudyCardExport,
    getTobStudyCardExportLog,
    getTobPosterList,
    getTobPosterInfo,
    tobPosterSave,
    getTobMarketing,
    tobBankConfirm,
    tobBankSave,
    getTobFolderList,
    getTobFolderFileList,
    tobMobile,
    getTobExperienceInfo,
    experienceAccountUpdate,
    getTobTongJiStudy,
    getTobSearchCreateUser,
    getTobStudents,
    getNoticeList,
    getTobNoticeInfo,
    getVideoList,
    getTobVideoInfo,
    studentsBatch,
    getHasOrderStudentCount,
    getTobStudentsInfo,
    getTobStudentsDatas,
    getTobHelpManualList,
    getTobHelpManualInfo,
    getActivityXcxCode,
    getCollegeNameList,
    getDzsCateMode2,
    getQuestionEdusPlan,
    getExamOutLintSubjects,
    getAreaList,
    getAllArea,
    getQuestionEdus,
    customOrderSave,
    getCustomOrderFlowing,
    getCustomOrderList,
    getExamoutlineSubjectMode2,
    getUserinfo,
    getTobGoodInfo
}
